<template>
  <div class="Login">
    <NotificationBar
      v-if="error"
      :message="error"
      level="error" />

    <div class="panel">
      <h1>Login PT</h1>
      <form @submit.prevent="login()">
        <div class="form-group">
          <label for="id-username">Username</label>
          <input
            id="id-username"
            type="email"
            v-model="username">
          <label for="id-password">Password</label>
          <input
            id="id-password"
            type="password"
            v-model="password">
        </div>
        <button
          class="btn"
          type="submit">
          Login
        </button>
      </form>
      <p>
        <router-link to="/reset">
          I forgot my password
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import NotificationBar from "@/components/NotificationBar";

export default {
  components: { NotificationBar },
  props: {
    nextUrl: {
      type: String,
      default: "/",
    },
  },
  data: function () {
    return {
      username: "",
      password: "",
      error: "",
    };
  },

  mounted() {
    const accessToken = this.$route.query.access_token;
    if (accessToken) {
      this.$store
        .dispatch("authenticate", { accessToken })
        .then(() => this.$store.dispatch("me"))
        .then(() => this.$router.replace({ path: this.nextUrl }));
    }
    if (this.$store.state.isAuthenticated) {
      this.$router.replace({ path: this.nextUrl });
    }
  },

  methods: {
    login() {
      this.error = "";
      this.$store
        .dispatch("login", { username: this.username, password: this.password })
        .then(() => {
          this.$router.push({ path: this.nextUrl });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.error = err.response.data.message;
          } else {
            this.error = err;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.Login {
  padding: 1em;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

button {
  width: 100%;
}

.panel {
  padding: 1em;
  justify-self: center;
  align-self: center;
}

h1 {
  text-align: center;
}
</style>
